module.exports = __webpack_public_path__ + "img/feedback.cbc9187.svg";